// 菜单配置
import _ from 'underscore'
import clone from 'clone'

// 框架页
import Index from '../views/Index.vue'

// 组件列表
const components = {
  // 仪表盘
  Dashboard: () => import(/* webpackChunkName: 'dashboard' */ '../views/dashboard/Index.vue'),

  // 商品管理
  CommodityCategory: () => import(/* webpackChunkName: 'commodity' */ '../views/commodity/Category.vue'),
  CommodityList: () => import(/* webpackChunkName: 'commodity' */ '../views/commodity/List.vue'),

  // 权益管理
  RechargeManual: () => import(/* webpackChunkName: 'recharge' */ '../views/recharge/Manual.vue'),
  RechargeBatch: () => import(/* webpackChunkName: 'recharge' */ '../views/recharge/Batch.vue'),
  RechargeBatchOrder: () => import(/* webpackChunkName: 'recharge' */ '../views/recharge/BatchOrder.vue'),
  RechargeManualPurchase: () => import(/* webpackChunkName: 'recharge' */ '../views/recharge/ManualPurchase.vue'),
  RechargeBatchImport: () => import(/* webpackChunkName: 'recharge' */ '../views/recharge/BatchImport.vue'),

  // 订单管理
  OrderRecharge: () => import(/* webpackChunkName: 'order' */ '../views/order/Recharge.vue'),
  ProductOrder: () => import(/* webpackChunkName: 'order' */ '../views/product/ProductOrder.vue'),
  OrderCarmi: () => import(/* webpackChunkName: 'order' */ '../views/order/Carmi.vue'),
  OrderManagement: () => import('@/views/order/Management.vue'),
  OrderItemManagement: () => import('@/views/order/OrderItem.vue'),

  // 供应商管理
  SupplierList: () => import(/* webpackChunkName: 'supplier' */ '../views/supplier/List.vue'),
  SupplierCommodity: () => import(/* webpackChunkName: 'supplier' */ '../views/supplier/Commodity.vue'),
  SupplierAccount: () => import(/* webpackChunkName: 'supplier' */ '../views/supplier/Account.vue'),

  // 代理商管理
  AgentList: () => import(/* webpackChunkName: 'agent' */ '../views/agent/List.vue'),
  AgentCommodity: () => import(/* webpackChunkName: 'agent' */ '../views/agent/Commodity.vue'),
  AgentOffer: () => import(/* webpackChunkName: 'agent' */ '../views/agent/offer/SupplierOffer.vue'),
  AgentAccount: () => import(/* webpackChunkName: 'agent' */ '../views/agent/Account.vue'),
  AgentApiList: () => import(/* webpackChunkName: 'agent' */ '../views/agent/ApiList/ApiList.vue'),

  // 系统管理
  SystemUser: () => import(/* webpackChunkName: 'system' */ '../views/system/User.vue'),
  SystemRole: () => import(/* webpackChunkName: 'system' */ '../views/system/Role.vue'),
  SystemMenu: () => import(/* webpackChunkName: 'system' */ '../views/system/Menu.vue'),
  SystemAuthorization: () => import(/* webpackChunkName: 'system' */ '../views/system/Authorization.vue'),
  SystemLog: () => import(/* webpackChunkName: 'system' */ '../views/system/Log.vue')
}

// 菜单配置
// 同vue router配置一致，除了下面二项，会根据配置自动生成路由和面包屑导航。
// 1：为添加菜单栏目，增加list数组属性，包含路由配置或子栏目，但不可包含path属性：
// path: '', 此属性不要为菜单栏目配置，请仅为有路由的菜单项配置
// meta: {
//   label: '栏目名称',
//   customIcon: '栏目图标'
// },
// list: [{路由配置},...]
// 2：在meta元数据中添加额外属性：
// - label: 菜单项名称
// - customIcon: iconfont图标
// - auth: 菜单项权限码
// - hide: 是否在菜单列表中隐藏
// - keepAlive: 视图是否常驻内存
// - homepage: 首页地址，以最后定义的为准
const menus = [
  {
    path: '/',
    meta: {
      label: '仪表盘',
      customIcon: 'iconfont icon-dashboard',
            homePage: true,
            keepAlive: true
    },
    component: components.Dashboard,
  }
]

// 生成路由
const generateRoute = (menus) => {
  let menusRouter = []
  let homePage = ''
  const handleRoute = (menus) => {
    _.each(menus, (item) => {
      if (item.path) {
        menusRouter.push(item)
        if (item.meta.homePage) {
          homePage = item.path
        }
      }
      if (item.list && item.list.length) {
        handleRoute(item.list)
      }
    })
  }
  handleRoute(clone(menus))
  menusRouter.push({
    path: '',
    redirect: homePage
  })
  return [{
    path: '/',
    component: Index,
    children: menusRouter
  }]
}

// 生成菜单
const handleMenus = (menus, oldMenus = []) => {
  if (!menus.length) {
    return {
      menus: oldMenus,
      permission: []
    }
  }
  const newMenus = []
  const permission = []
  const recursion = function (menus, newMenus) {
    const dataLength = menus.length
    for (let i = 0; i < dataLength; i++) {
      const item = menus[i]
      if (item.type === 2) { // btn
        if (item.perms) {
          permission.push({
            name: item.parentName + '-' + item.name,
            auth: item.perms,
            path: item.url,
            component: item.component
          })
        }
        if (item.url && item.component && components[item.component]) {
          newMenus.push({
            meta: {
              label: item.name || '',
              auth: item.perms || '',
              hide: true,
              homePage: item.homePage // 子菜单也可以有首页标识
            },
            path: item.url,
            component: components[item.component]
          })
        }
      } else { // menu
        const newItem = {
          meta: {
            label: item.name || '',
            customIcon: item.icon ? 'iconfont ' + item.icon : '',
            auth: item.perms || '',
            hide: !!item.hidden,
            homePage: item.homePage // 子菜单也可以有首页标识
          }
        }
        if (item.list && item.list.length) {
          newItem.list = []
          recursion(item.list, newItem.list)
        }
        if (item.url && item.component && components[item.component]) {
          newItem.path = item.url
          newItem.component = components[item.component]
        }
        newMenus.push(newItem)
      }
    }
  }
  recursion(menus, newMenus)
  return {
    menus: oldMenus.concat(newMenus),
    permission: permission
  }
}

// fixed menus
const fixedMenus = [
  {
    menuId: 4,
    parentId: 0,
    parentName: null,
    name: '供应商管理',
    url: '',
    perms: null,
    type: 1,
    level: 1,
    icon: 'icon-audit',
    orderNum: 0,
    list: [
      {
        menuId: 41,
        parentId: 4,
        parentName: '供应商管理',
        name: '供应商列表',
        homePage: true,
        url: '/supplier/list',
        perms: null,
        type: 1,
        level: 2,
        icon: '',
        orderNum: 0,
        list: [],
        hidden: 0,
        status: 1,
        component: 'SupplierList'
      },
      {
        menuId: 42,
        parentId: 4,
        parentName: '供应商管理',
        name: '供应商商品列表',
        url: '/supplier/commodity',
        perms: null,
        type: 1,
        level: 2,
        icon: '',
        orderNum: 0,
        list: [],
        hidden: 0,
        status: 1,
        component: 'SupplierCommodity'
      },
      {
        menuId: 43,
        parentId: 4,
        parentName: '供应商管理',
        name: '供应商对账流水',
        url: '/supplier/account',
        perms: null,
        type: 1,
        level: 2,
        icon: '',
        orderNum: 0,
        list: [],
        hidden: 0,
        status: 1,
        component: 'SupplierAccount'
      }
    ]
  },
  {
    menuId: 1,
    parentId: 0,
    parentName: null,
    name: '商品管理',
    url: '',
    perms: null,
    type: 1,
    level: 1,
    icon: 'icon-appstore',
    orderNum: 0,
    list: [
      {
        menuId: 11,
        parentId: 1,
        parentName: '商品管理',
        name: '商品分类',
        url: '/commodity/category',
        perms: null,
        type: 1,
        level: 2,
        icon: '',
        orderNum: 0,
        list: [],
        hidden: 0,
        status: 1,
        component: 'CommodityCategory'
      },
      {
        menuId: 12,
        parentId: 1,
        parentName: '商品管理',
        name: '商品列表',
        url: '/commodity/list',
        perms: null,
        type: 1,
        level: 2,
        icon: '',
        orderNum: 0,
        list: [],
        hidden: 0,
        status: 1,
        component: 'CommodityList'
      }
    ]
  },
  // {
  //   menuId: 2,
  //   parentId: 0,
  //   parentName: null,
  //   name: '权益管理',
  //   url: '',
  //   perms: null,
  //   type: 1,
  //   level: 1,
  //   icon: 'icon-YUAN',
  //   orderNum: 0,
  //   list: [
  //     {
  //       menuId: 21,
  //       parentId: 2,
  //       parentName: '权益管理',
  //       name: '充值类',
  //       url: '',
  //       perms: null,
  //       type: 1,
  //       level: 2,
  //       icon: '',
  //       orderNum: 0,
  //       list: [
  //         {
  //           menuId: 211,
  //           parentId: 21,
  //           parentName: '充值类',
  //           name: '手动充值',
  //           url: '/recharge/manual',
  //           perms: null,
  //           type: 1,
  //           level: 3,
  //           icon: '',
  //           orderNum: 0,
  //           list: [],
  //           hidden: 0,
  //           status: 1,
  //           component: 'RechargeManual'
  //         },
  //         {
  //           menuId: 212,
  //           parentId: 21,
  //           parentName: '充值类',
  //           name: '批量充值',
  //           url: '/recharge/batch',
  //           perms: null,
  //           type: 1,
  //           level: 3,
  //           icon: '',
  //           orderNum: 0,
  //           list: [],
  //           hidden: 0,
  //           status: 1,
  //           component: 'RechargeBatch'
  //         },
  //         {
  //           menuId: 213,
  //           parentId: 21,
  //           parentName: '充值类',
  //           name: '批量充值订单',
  //           url: '/recharge/batch/order',
  //           perms: null,
  //           type: 1,
  //           level: 3,
  //           icon: '',
  //           orderNum: 0,
  //           list: [],
  //           hidden: 0,
  //           status: 1,
  //           component: 'RechargeBatchOrder'
  //         }
  //       ]
  //     },
  //     {
  //       menuId: 22,
  //       parentId: 2,
  //       parentName: '权益管理',
  //       name: '卡密类',
  //       url: '',
  //       perms: null,
  //       type: 1,
  //       level: 2,
  //       icon: '',
  //       orderNum: 0,
  //       list: [
  //         {
  //           menuId: 221,
  //           parentId: 22,
  //           parentName: '卡密类',
  //           name: '批量导入',
  //           url: '/recharge/batchImport',
  //           perms: null,
  //           type: 1,
  //           level: 3,
  //           icon: '',
  //           orderNum: 0,
  //           list: [],
  //           hidden: 0,
  //           status: 1,
  //           component: 'RechargeBatchImport'
  //         },
  //         {
  //           menuId: 221,
  //           parentId: 22,
  //           parentName: '卡密类',
  //           name: '手动购买',
  //           url: '/recharge/manualPurchase',
  //           perms: null,
  //           type: 1,
  //           level: 3,
  //           icon: '',
  //           orderNum: 0,
  //           list: [],
  //           hidden: 0,
  //           status: 1,
  //           component: 'RechargeManualPurchase'
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    menuId: 5,
    parentId: 0,
    parentName: null,
    name: '代理商管理',
    url: '',
    perms: null,
    type: 1,
    level: 1,
    icon: 'icon-solution',
    orderNum: 0,
    list: [
      {
        menuId: 51,
        parentId: 5,
        parentName: '代理商管理',
        name: '代理商列表',
        url: '/agent/list',
        perms: null,
        type: 1,
        level: 2,
        icon: '',
        orderNum: 0,
        list: [],
        hidden: 0,
        status: 1,
        component: 'AgentList'
      },
      {
        menuId: 51,
        parentId: 5,
        parentName: '代理商管理',
        name: '代理商产品管理',
        url: '/agent/offer',
        perms: null,
        type: 1,
        level: 2,
        icon: '',
        orderNum: 0,
        list: [],
        hidden: 0,
        status: 1,
        component: 'AgentOffer'
      },
      {
        menuId: 54,
        parentId: 5,
        parentName: '代理商管理',
        name: '代理商接口权限管理',
        url: '/agent/apiList',
        perms: null,
        type: 1,
        level: 2,
        icon: '',
        orderNum: 0,
        list: [],
        hidden: 0,
        status: 1,
        component: 'AgentApiList'
      },
      {
        menuId: 52,
        parentId: 5,
        parentName: '代理商管理',
        name: '代理商商品列表',
        url: '/agent/commodity',
        perms: null,
        type: 1,
        level: 2,
        icon: '',
        orderNum: 0,
        list: [],
        hidden: 0,
        status: 1,
        component: 'AgentCommodity'
      },
      {
        menuId: 53,
        parentId: 5,
        parentName: '代理商管理',
        name: '代理商对账流水',
        url: '/agent/account',
        perms: null,
        type: 1,
        level: 2,
        icon: '',
        orderNum: 0,
        list: [],
        hidden: 0,
        status: 1,
        component: 'AgentAccount'
      }
    ]
  },

  {
    menuId: 3,
    parentId: 0,
    parentName: null,
    name: '订单管理',
    url: '',
    perms: null,
    type: 1,
    level: 1,
    icon: 'icon-file-text',
    orderNum: 0,
    list: [
      {
        menuId: 31,
        parentId: 3,
        parentName: '订单管理',
        name: '订购明细',
        url: '/order/recharge',
        perms: null,
        type: 1,
        level: 2,
        icon: '',
        orderNum: 0,
        list: [],
        hidden: 0,
        status: 1,
        component: 'ProductOrder'
      },
      {
        menuId: 33,
        parentId: 3,
        parentName: '订单管理',
        name: '订单管理',
        url: '/order/management',
        perms: null,
        type: 1,
        level: 2,
        icon: '',
        orderNum: 0,
        list: [],
        hidden: 0,
        status: 1,
        component: 'OrderManagement'
      },
      {
        menuId: 32,
        parentId: 3,
        parentName: '订单管理',
        name: '下发明细',
        url: '/order/items',
        perms: null,
        type: 1,
        level: 2,
        icon: '',
        orderNum: 0,
        list: [],
        hidden: 0,
        status: 1,
        component: 'OrderItemManagement'
      }
    ]
  }
  // {
  //   menuId: 6,
  //   parentId: 0,
  //   parentName: null,
  //   name: '系统管理',
  //   url: '',
  //   perms: null,
  //   type: 1,
  //   level: 1,
  //   icon: 'icon-setting',
  //   orderNum: 0,
  //   list: [
  //     {
  //       menuId: 61,
  //       parentId: 6,
  //       parentName: '系统管理',
  //       name: '用户管理',
  //       url: '/system/user',
  //       perms: null,
  //       type: 1,
  //       level: 2,
  //       icon: '',
  //       orderNum: 0,
  //       list: [],
  //       hidden: 0,
  //       status: 1,
  //       component: 'SystemUser'
  //     },
  //     {
  //       menuId: 62,
  //       parentId: 6,
  //       parentName: '系统管理',
  //       name: '角色管理',
  //       url: '/system/role',
  //       perms: null,
  //       type: 1,
  //       level: 2,
  //       icon: '',
  //       orderNum: 0,
  //       list: [],
  //       hidden: 0,
  //       status: 1,
  //       component: 'SystemRole'
  //     },
  //     {
  //       menuId: 63,
  //       parentId: 6,
  //       parentName: '系统管理',
  //       name: '菜单管理',
  //       url: '/system/menu',
  //       perms: null,
  //       type: 1,
  //       level: 2,
  //       icon: '',
  //       orderNum: 0,
  //       list: [],
  //       hidden: 0,
  //       status: 1,
  //       component: 'SystemMenu'
  //     },
  //     {
  //       menuId: 64,
  //       parentId: 6,
  //       parentName: '系统管理',
  //       name: '权限管理',
  //       url: '/system/authorization',
  //       perms: null,
  //       type: 1,
  //       level: 2,
  //       icon: '',
  //       orderNum: 0,
  //       list: [],
  //       hidden: 0,
  //       status: 1,
  //       component: 'SystemAuthorization'
  //     },
  //     {
  //       menuId: 65,
  //       parentId: 6,
  //       parentName: '系统管理',
  //       name: '日志管理',
  //       url: '/system/log',
  //       perms: null,
  //       type: 1,
  //       level: 2,
  //       icon: '',
  //       orderNum: 0,
  //       list: [],
  //       hidden: 0,
  //       status: 1,
  //       component: 'SystemLog'
  //     }
  //   ]
  // }
]

export { components, menus, generateRoute, handleMenus, fixedMenus }
